<template>
    <page title="performancesTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <v-col cols="12" md="12" class="py-1">
                    <v-card v-if="showGrid">
                        <v-data-table
                            :headers="headers"
                            :items="Performances"
                            item-key="id"
                            class="elevation-1"
							:page.sync="PerformancePagination.currentPage"
							groupBy= "eventType"   
							:items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.manualBestlistsLoading')"
                            :server-items-length="PerformancePagination.totalCount"
                            hide-default-footer
							:height="WindowSize.y - 434"
							show-group-by
                            fixed-header hide-default-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
									<v-row v-if="!!manualBestlist">
										<v-col class="manualBestlist-name">
											{{ getSetHeader }}
										</v-col>
									</v-row>
                                    <v-row>
                                        <v-col cols="12" sm="3" lg="2">
                                            <v-btn-toggle dense>
                                                <v-btn
                                                    @click="back">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.backToOverview`) }}
                                                    </span>
                                                    <v-icon>
                                                        mdi-keyboard-backspace
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                        <v-col cols="12" sm="3" lg="2">
                                            <v-btn-toggle dense color="primary">
                                                <v-btn
                                                    color="primary"
                                                    @click="newPerformance">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newPerformance`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
										<v-col cols="12" sm="3" lg="4">
                                            <v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.freetextSearch"
                                                :label="$t('text.name')"
                                                @keyup.enter.native="search">
                                            </v-text-field>
                                        </v-col>
										<v-col cols="12" sm="2" lg="2">
                                            <v-autocomplete outlined dense
												hide-details="auto"
                                                class="mt-0 pt-0"
                                                v-model="tempQP.event"
                                                :items="events"
                                                clearable
                                                :label="$t('text.event')"
												:disabled="!hasEvents"
                                                :loading="loading"
                                                @keyup.enter.native="filter">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="2" lg="2"
											align="right">
                                            <v-btn-toggle dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
							<template
								v-slot:header="{ props: { headers } }">
								<thead>
									<tr><th v-for="(h, i) in headers" :key="i" :style="{width:h.width}">
										{{h.text}}
									</th></tr>
								</thead>
							</template>
							<template v-slot:group="props">
								<tr><td :colspan="props.headers.length">
								<div class="font-weight-bold">
									{{ props.group }}
								</div>
								</td></tr>
								<tr><td :colspan="props.headers.length" :style="{'padding-left':'0px'}">
								<v-data-table
									:headers="props.headers"
									:items="props.items"
									item-key="name"
									:items-per-page="400"
									hide-default-footer hide-default-header>
									<template
										v-slot:header="{ props: { headers } }">
										<thead>
											<tr><td v-for="(h, i) in headers" :key="i" :style="{width:h.width, height:'0px'}">
											</td></tr>
										</thead>
									</template>
									<template #[`item.action`]="{ item }">
										<v-tooltip bottom>
											<template #activator="{ on }">
												<v-btn icon v-on="on"
													@click="edit(item.id)">
													<v-icon>
														edit
													</v-icon>
												</v-btn>
												</template>
											<span>{{ $t(`text.edit`) }}</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template #activator="{ on }">
												<v-btn icon v-on="on"
													@click="requestDelete(item.id)">
													<v-icon>
														delete
													</v-icon>
												</v-btn>
												</template>
											<span>{{ $t(`text.delete`) }}</span>
										</v-tooltip>
									</template>
									<template #[`item.athleteFirstname`]="{ item }">										
										{{ `${formatAthletename(item.athleteFirstname,item.athleteLastname,item.athleteIocCode )}` }}
									</template>
									<template #[`item.formatedValue`]="{ item }">
										{{ `${item.formatedValue}` }}<template v-if="item.windSpeed !== null">{{ ` (${formatWind(item.windSpeed)})` }}</template>
									</template>
									<template #[`item.event`]="{ item }">
										{{ `${getEventLongNameByiShort(item.internationalEventShort)}` }}
									</template>
									<template #[`item.performanceTown`]="{ item }">
										{{ `${item.performanceTown} (${item.performanceCountry})` }}
									</template>
									<template #[`item.date`]="{ item }">
										{{ `${formatDate(item.date)}` }}
									</template>
								</v-data-table>
								</td></tr>
							</template>

                        </v-data-table>

                        <pagination
                            :currentPage="PerformancePagination.currentPage"
                            :totalPages="PerformancePagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>
			<pop-up v-model="confirmReturn"
				:show="showConfirm"
				text="deleteRequest"
				:title="null"
				type="confirm"
				@change="callOnConfirmDelete"
				:props="{id: requestDeleteId}"></pop-up>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';
import PopUp from '../general/PopUp.vue';

import manualBestlistsActions from '../store/actions/manualBestlists';
import definitionsActions from '../store/actions/definitions';
import namespace from '../store/namespace';

import formater from '../mixins/formater';

import getEventTypes from '../models/eventType';

class TempPerformancesQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.event = qp.event;
		}
	}
}

class PerformancesQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
			this.event = qp.event;
		} else {
			this.pageNumber = 1;
			this.pageSize = 10;
			this.freetextSearch = '';
			this.event = null;
		}
	}

	updateTempData(tempQP) {
		this.freetextSearch = tempQP.freetextSearch;
		this.event = tempQP.event;
	}
}

export default {
	name: 'Performances',
	components: {
		Page,
		Pagination,
		PopUp,
	},
	mixins: [formater],
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: '104px',
				},
				{
					text: this.$i18n.t('text.name'), align: 'left', value: 'athleteFirstname', sortable: false,
				},
				{
					text: this.$i18n.t('text.event'), align: 'left', value: 'event', sortable: false, width: '200px',
				},
				{
					text: this.$i18n.t('text.bestResult'), align: 'left', value: 'formatedValue', sortable: false, width: '200px',
				},
				{
					text: this.$i18n.t('text.location'), align: 'left', value: 'performanceTown', sortable: false, width: '300px',
				},
				{
					text: this.$i18n.t('text.date'), align: 'left', value: 'date', sortable: false, width: '104px',
				},
			],
			loading: true,
			queryParameters: new PerformancesQueryParameter(),
			tempQP: new TempPerformancesQueryParameter(),
			manualBestlist: null,
			showConfirm: false,
			confirmReturn: 0,
			requestDeleteId: null,
			id: this.$route.params.id || null,
			showGrid: false,
			eventTypes: getEventTypes(this),
			events: [],
			help: [
				{
					icon: 'delete',
					text: this.$t('text.delete'),
				},
				{
					icon: 'edit',
					text: this.$t('text.edit'),
				}],
		};
	},
	async mounted() {
		if (localStorage.getItem('performancesApp')) {
			this.queryParameters = new PerformancesQueryParameter(JSON.parse(localStorage.getItem('performancesApp')));
			this.tempQP = new TempPerformancesQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('performancesApp', JSON.stringify(this.queryParameters));
		}
		await this.loadData();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.DEFINITIONS, ['Events', 'DefinitionsLinks']),
		...mapGetters(namespace.MANUALBESTLISTS, ['PerformanceLinks', 'ManualBestlistLinks', 'Performances', 'PerformancePagination']),
		nonContentPage() {
			return this.Performances.length == 0;
		},
		getSetHeader() {
			return `${this.manualBestlist.name}`;
		},
		hasEvents() {
			return this.events?.length != 0;
		},
	},
	watch: {
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('performancesApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	methods: {
		...mapActions(namespace.MANUALBESTLISTS, [
			manualBestlistsActions.GET_PERFORMANCES_LINKS,
			manualBestlistsActions.GET_MANUALBESTLIST_LINKS,
			manualBestlistsActions.GET_MANUALBESTLISTBYID,
			manualBestlistsActions.GET_PERFORMANCES,
			manualBestlistsActions.DELETE_PERFORMANCE,
			manualBestlistsActions.GET_EVENTS_BY_BESTLIST_ID,
		]),
		...mapActions(namespace.DEFINITIONS, [
			definitionsActions.GET_DEFINITIONS_LINKS,
			definitionsActions.GET_EVENTS_BY_NSHORT,
		]),
		async getPerformancesLinks() {
			try {
				await this.GET_PERFORMANCES_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async getManualBestlistLinks() {
			try {
				await this.GET_MANUALBESTLIST_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async getDefinitionLinks() {
			try {
				await this.GET_DEFINITIONS_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async getEvents() {
			try {
				if (this.id) {
					const e = await this.GET_EVENTS_BY_BESTLIST_ID(this.id);
					this.events = e.map(x => ({ value: x.shortInternational, text: x.longname }));
				}
			} catch (ex) {
				console.log(ex);
			}
		},
		async search() {
			this.queryParameters.updateTempData(this.tempQP);
			localStorage.setItem('performancesApp', JSON.stringify(this.queryParameters));
			this.queryParameters.pageNumber = 1;
			await this.loadData();
		},
		async loadData() {
			this.loading = true;
			try {
				if (!this.PerformanceLinks.length) {
					await this.getPerformancesLinks();
				}
				if (!this.ManualBestlistLinks.length) {
					await this.getManualBestlistLinks();
				}
				this.manualBestlist = await this.GET_MANUALBESTLISTBYID(this.id);
				if (!this.DefinitionsLinks.length) {
					await this.getDefinitionLinks();
				}
				await this.GET_EVENTS_BY_NSHORT(this.manualBestlist.nationalClassShort);
				const performancesRequest = {
					manualBestlistId: this.id,
					queryParameters: this.queryParameters,
				};
				this.showGrid = false;
				await this.getEvents();

				await this.GET_PERFORMANCES(performancesRequest);
				this.Performances.forEach(r => this.enrichPerformances(r));
				this.showGrid = true;
				if (this.nonContentPage) {
					this.queryParameters.pageNumber = this.PerformancePagination.totalPages;
				}
			} finally {
				this.loading = false;
			}
		},
		async filter() {
			this.queryParameters.updateTempData(this.tempQP);
			await this.loadData();
		},
		async pageSizeChanged(newPageSize) {
			this.queryParameters.pageSize = newPageSize;
			const maxPage = Math.ceil(this.PerformancePagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.PerformancePagination.currentPage ? maxPage : this.PerformancePagination.currentPage;

			await this.loadData();
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;

			await this.loadData();
		},
		newPerformance() {
			this.$router.push({
				name: 'newmanualbestlistperformance',
				params: {
					manualBestlistId: this.id,
				},
			});
		},
		async edit(id) {
			this.$router.push({
				name: 'updatemanualbestlistperformance',
				params: {
					id,
				},
			});
		},
		back() {
			this.$router.push({
				name: 'manualbestlists',
			});
		},
		formatDate(date) {
			return this.gFormatDate(date);
		},
		formatAthletename(firstname, lastname, ioc) {
			if (firstname !== undefined && firstname !== null) { 
				return firstname + ' ' + lastname + ' (' + ioc + ')'; 
				}
			return lastname + ' (' + ioc + ')';
		},
		formatWind(wind) {
			return wind < 0 ? `${wind.toFixed(1)}` : `+${wind.toFixed(1)}`;
		},
		enrichPerformances(item) {
			const ev = this.Events.find(x => x.shortInternational === item.internationalEventShort);
			item.eventType = this.eventTypes.find(x => x.value == ev.eventType).text;
		},
		getEventLongNameByiShort(short) {
			return this.Events.find(x => x.shortInternational === short).longname;
		},
		requestDelete(id) {
			this.requestDeleteId = id;
			this.showConfirm = true;
		},
		async callOnConfirmDelete(value, props) {
			if (value === 1) {
				this.showConfirm = false;
				this.loading = true;
				try {
					await this.DELETE_PERFORMANCE(props.id);
					await this.loadData();
				} catch (ex) {
					console.log(ex);
				}

				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>

.manualBestlist-name {
	text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #e4af0c;
}

.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}
</style>
